import React, { memo, useState, useRef, useMemo } from 'react';
import styles from './sort.module.scss';
import { useGlobalDataContext } from '@context/GlobalData/GlobalDataContext';
import { useLoading } from '@context/Loading/LoadingContext';
import { sortConfig, searchStates } from '@config';
import { GrFormClose } from 'react-icons/gr';

// const SortMobile = ({ OnclickCloseModal }) =>

const SortMobile = props => {
    const { globalContext, setGlobalContext } = useGlobalDataContext();
    const { setLoading } = useLoading();
    const [sortOptions] = useState(sortConfig);

    const handleSortChange = sortValue => {
        setLoading(true);

        props.OnclickCloseModal();

        setGlobalContext(prevContext => ({
            ...prevContext,
            start: 1,
            sort: sortValue,
            searchState: searchStates.UPDATING,
            prevSearchState: prevContext.searchState
        }));
    };

    const sortOptionList = useMemo(() =>
        sortOptions.sort((a, b) => a - b, [sortOptions])
    );

    return (
        <div className={styles.op_sort_mobile}>
            <div className={styles.container_header_sort}>
                <span className={styles.sort__title}>Sorteren</span>
                <button
                    type="button"
                    onClick={props.OnclickCloseModal}
                    className={styles.close_btn}
                >
                    <GrFormClose />
                </button>
            </div>
            <fieldset>
                {sortOptionList.map(sort => (
                        <div className={styles.label_container}>
                            <input
                                type="radio"
                                id={sort.label}
                                name="sort"
                                value={sort.value}
                                onChange={() => {
                                    handleSortChange(sort.value);
                                }}
                                checked={sort.value === globalContext.sort}
                            />
                            <label htmlFor={sort.label}>{sort.label}</label>
                        </div>   
                ))}
            </fieldset>
        </div>
    );
};

export default SortMobile;
